export default require('./config');



// WEBPACK FOOTER //
// ./src/config/index.js